import { createApp } from 'vue'
import { createI18n } from 'vue-i18n'
import App from './App.vue'
import router from './router'

import en from './locales/en.json'
import zh from './locales/zh.json'

const urlParams = new URLSearchParams(window.location.search)
const lang = urlParams.get('lang') || 'zh-TW' // 如果沒有 lang 參數，默認使用中文

const i18n = createI18n({
  // 您的 i18n 選項
  legacy: false, // 使用 Composition API 模式
  locale: lang, // 設置默認語言
  fallbackLocale: 'en',
  messages: {
    en,
    zh
  }
})

createApp(App).use(router).use(i18n).mount('#app')
